import { AutoAwesomeRoundedSVG } from '@modules/common/components/AutoAwesomeRoundedSVG';
import { Stack, Typography } from '@mui/material';

interface FeedbackListSummaryHeaderProps {
  hasNoSummary?: boolean;
}

export function FeedbackListSummaryHeader({
  hasNoSummary,
}: FeedbackListSummaryHeaderProps) {
  return (
    <Stack direction="row" alignItems="center" spacing={1} zIndex={1}>
      {!hasNoSummary && <AutoAwesomeRoundedSVG />}
      <Typography
        variant="body1"
        component={Stack}
        fontWeight={500}
        direction="row"
        alignItems="center"
      >
        {hasNoSummary ? (
          <Typography variant="h6" color="text.primary">
            No Summary Generated
          </Typography>
        ) : (
          <>Summary</>
        )}
      </Typography>
    </Stack>
  );
}
